/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, getter-return */
import Component from '@ember/component';
import { computed } from '@ember/object';
import NswSapSyncStatus from 'linced-app/enums/nsw-sap-sync-status';
import { tagName } from '@ember-decorators/component';

@tagName('')
export default class SapSyncStatus extends Component {
  // entity is the Finance entity whose SAP sync status should be shown.
  entity = null;

  // dialogOpen determines whether to show the dialog with error details.
  dialogOpen = false;

  @computed('entity.nswSapStatus')
  get buttonClasses() {
    switch (this.get('entity.nswSapStatus')) {
      case NswSapSyncStatus.CONFIRMED:
        return 'small md-success';
      case NswSapSyncStatus.FAILED:
        return 'small md-warn';
    }
    return 'small';
  }

  @computed('entity.nswSapStatus')
  get icon() {
    switch (this.get('entity.nswSapStatus')) {
      case NswSapSyncStatus.UPLOADED:
      case NswSapSyncStatus.ACKNOWLEDGED:
        return 'cloud-arrow-up';
      case NswSapSyncStatus.CONFIRMED:
        return 'cloud-check';
      case NswSapSyncStatus.FAILED:
        return 'cloud-warning';
    }
  }

  @computed('entity.nswSapStatus')
  get tooltip() {
    switch (this.get('entity.nswSapStatus')) {
      case NswSapSyncStatus.UPLOADED:
        return 'Uploaded to SAP';
      case NswSapSyncStatus.ACKNOWLEDGED:
        return 'Acknowledged by SAP';
      case NswSapSyncStatus.CONFIRMED:
        return 'Confirmed by SAP';
      case NswSapSyncStatus.FAILED:
        return 'SAP error - click for details';
    }
  }

  NswSapSyncStatus = NswSapSyncStatus;
}
